module.exports={
    download_title: '让财富近在咫尺',
    download_description:'你需要的一切都在UPlus 应用程序中',
    download_robot:'全自动量化交易机器人',
    download_trusted:'百万加密货币投资者的信赖',
    ios_profile_download:'iOS 描述文件下载'
}